import { render, staticRenderFns } from "./XunjiaPaybjz.vue?vue&type=template&id=8fd2469e"
import script from "./XunjiaPaybjz.vue?vue&type=script&lang=js"
export * from "./XunjiaPaybjz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports